import React, { useMemo, useState } from 'react';
import { uniqueId } from 'lodash';
import { mailTemplatesUrl } from '@dashboard/services/env';
import MailIframePreview from '@dashboard/components/MailIframePreview';

interface Props {
  pageId: string;
}

const StaffInviteEmailPreview: React.FC<Props> = ({ pageId }) => {
  // Force a fresh load each time the dialog opens.
  const [previewKey] = useState(() => uniqueId('staff-invite-'));
  const src = useMemo(
    () => `${mailTemplatesUrl}/event-staff-invite-email/${pageId}?previewKey=${previewKey}`,
    [pageId, previewKey],
  );

  return <MailIframePreview src={src} previewKey={previewKey} title="Staff invite email preview" />;
};

export default StaffInviteEmailPreview;
